export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8249.62b0bbc8.jpg";